import { Announcements } from 'modules/announcements';
import { SliderContainer } from 'modules/nav/components/SliderContainer';
import { QuickActionsMenuContextProvider } from 'modules/quickActionsMenu/contexts';
import { NAVBAR_VARIANTS } from 'modules/nav/constants/navigation';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';

import { Header } from '../Header';
import { PropsWithChildren } from 'react';
import BgGradient from './BgGradient.svg';

const App = styled.div<{ $navBarOffset: string }>`
  min-height: 100vh;
  width: 100vw;
  max-width: 100vw;
  padding-top: ${({ $navBarOffset }) => $navBarOffset};
  background-color: ${colors.backgroundSecondary};
  background-image: url(${BgGradient});
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-attachment: fixed;
`;

const Content = styled.main`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-top: ${spacing.layoutTopPadding};
`;

type HomepageLayoutProps = PropsWithChildren<{}>;

export const HomepageLayout = ({ children }: HomepageLayoutProps) => {
  const height = useNavBarHeight();

  return (
    <QuickActionsMenuContextProvider>
      <App $navBarOffset={pxToRem(height)}>
        <Header variant={NAVBAR_VARIANTS.NOVA} />
        <Announcements />
        <Content data-id="homepage-layout">{children}</Content>
        <SliderContainer />
      </App>
    </QuickActionsMenuContextProvider>
  );
};
